import { DatePipe, NgClass, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RegistrationService } from '@core/http/registration.service';
import { SolicitudRegistroStatus } from '@core/models/Registration';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-registration-status',
  standalone: true,
  imports: [
    NgIf,
    NgClass,
    DatePipe,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './registration-status.component.html',
  styleUrl: './registration-status.component.scss',
})
export class RegistrationStatusComponent implements OnInit {
  form = this.fb.group({
    folio: ['', [Validators.required]],
  });

  loading = false;
  result: SolicitudRegistroStatus | null = null;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private registrationService: RegistrationService,
  ) {}

  ngOnInit(): void {
    const folio = (this.route.snapshot.queryParamMap.get('folio') ?? '').trim();
    if (!folio) return;

    this.form.patchValue({ folio });
    this.search();
  }

  search(): void {
    this.form.markAllAsTouched();
    if (this.form.invalid) return;

    const folio = String(this.form.get('folio')?.value ?? '').trim();
    if (!folio) return;

    this.loading = true;
    this.result = null;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { folio },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });

    this.registrationService.getRequestStatusByFolio(folio).subscribe({
      next: (response) => {
        this.loading = false;
        this.result = response.data ?? null;
      },
      error: (error) => {
        this.loading = false;
        this.result = null;

        const message =
          error?.error?.message ||
          error?.error?.descripcion?.[0] ||
          'NO SE PUDO CONSULTAR EL ESTATUS DEL FOLIO.';

        Swal.fire('CONSULTA NO DISPONIBLE', message, 'error').then();
      },
    });
  }

  get statusClass(): string {
    const status = String(this.result?.estatus ?? '').toUpperCase();
    if (status === 'APROBADA') return 'approved';
    if (status === 'RECHAZADA') return 'rejected';
    return 'pending';
  }
}
